class BlockTabs {
	constructor() {
		const tabs = document.querySelectorAll(".nav-tabs li");
		const sections = document.querySelectorAll(".tab-section");

		tabs.forEach((tab) => {
			const eventTabChange = new Event('tabChange');
			let tabIndex = tab.dataset.tab;

			tab.addEventListener('click', () => {
				let newSections = document.querySelectorAll(".tab-section[data-tab='"+tabIndex+"']");


				tabs.forEach((elem) => {
					elem.classList.remove('active');
				});
				sections.forEach((elem) => {
					elem.classList.remove('active');
				});
				newSections.forEach((elem) => {
					elem.classList.add('active');
				});
				tab.classList.add('active');

				document.dispatchEvent(eventTabChange);
				ScrollTrigger.refresh();
			});
		});
	}
}